import React from "react";
import { Link as RouterLink, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { getWindow } from "ssr-window";

class FooterItem extends React.Component {
  click = (e) => {
    e.preventDefault();
    const {
      history: { push },
      location: { pathname },
      item,
    } = this.props;
    if (pathname === item.path) {
      getWindow().location.reload();
    } else {
      push(item.path);
    }
  };

  render() {
    const { item } = this.props;
    return (
      <RouterLink className="footer-item" to="" onClick={this.click}>
        {item.name}
      </RouterLink>
    );
  }
}

FooterItem.propTypes = {
  item: PropTypes.shape({
    path: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  click: PropTypes.func,
};

FooterItem.defaultProps = {
  click: undefined,
};

export default withRouter(FooterItem);
